import to from 'await-to-js';
import axios from 'axios';
import { makeUrl } from '@voomly/utils';
import { IFunnelRaw } from '../../types/funnels';

export const fetchPublicInfoFunnel = async (funnelId: string) => {
  const [err, response] = await to(
    axios.get<IFunnelRaw>(makeUrl(`/video-funnels/${funnelId}`))
  );

  if (response) {
    return response.data;
  } else {
    throw err;
  }
};
